<script lang="ts">
  import type { MarkComponentProps } from '@portabletext/svelte';
  import { analyticsStore } from '$lib/analytics/store';
  import { modals } from '$lib/stores/modals';

  // Property custom marks receive from @portabletext/svelte when redered
  export let portableText: MarkComponentProps<{
    _key: string;
    declineCookie?: boolean;
  }>;

  let modalBtn: HTMLElement;

  function handleOpenModal() {
    analyticsStore.declineAnalytics();
    modals.open('declineCookie', modalBtn);
  }
</script>

{#if portableText.value?.declineCookie}
  <button
    class="decline-cookie-btn"
    aria-label="Opt out of cookies"
    bind:this={modalBtn}
    on:click={handleOpenModal}
  >
    <slot />
  </button>
{:else}
  <slot />
{/if}

<style lang="scss">
  .decline-cookie-btn {
    background: transparent;
    display: inline-block;
    padding: 0;
    border: none;
    cursor: pointer;
    text-decoration: underline;

    font-size: inherit;
    font-family: inherit;
    line-height: inherit;
    color: inherit;
  }
</style>
